import React from 'react'

import { Table, TableRow } from '../../../../../components/pdf/Table'
import { TableColLabelValue } from '../../../../../components/pdf/TableHelpers'
import Text from '../../../../../components/pdf/Text'
import Bar from '../../../../../components/pdf/Bar'
import View from '../../../../../components/pdf/View'
import Grid, { Col } from '../../../../../components/pdf/Grid'
import Separator from '../../../../../components/pdf/Separator'
import { getAddressValue, getPlaceFieldValue } from '../../_helpers/pdfHelpers'
import { useServiceOrder } from '../../_load/ServiceOrderLoader'
import { formatCnpj } from '@btime/helpers'

const ClientData = ({ type }) => {
  const serviceOrder = useServiceOrder()

  const name =
    serviceOrder.place.placeLevelsResume.length > 2
      ? serviceOrder.place.placeLevelsResume[2].name
      : serviceOrder.place.resume
  const placeName = serviceOrder.place.name

  const cnpj = formatCnpj(getPlaceFieldValue(serviceOrder.place, 'CPF/CNPJ').toString())

  const contact = type === 'VIVO' ? getPlaceFieldValue(serviceOrder.place, 'Contato') : 'Maykon L. Byryno'
  const email =
    type === 'VIVO' ? getPlaceFieldValue(serviceOrder.place, 'Email 1') : 'manutencao.rdbrasil@segurpro.com.br'

  return (
    <View>
      <Grid justify="space-between" align="center">
        <Col>
          <Text bold size="h4" align="left">
            Dados do Cliente
          </Text>
        </Col>
      </Grid>
      <Table width="100%">
        <TableRow>
          <TableColLabelValue colSpan={2} label={'Nome/Razão Social'} value={name} />
        </TableRow>
        <TableRow>
          <TableColLabelValue colSpan={2} label={'Nome Fantasia'} value={`${name} ${placeName}`} />
        </TableRow>
        <TableRow>
          <TableColLabelValue colSpan={2} label={'CNPJ/CPF'} value={cnpj} />
        </TableRow>

        <TableRow>
          <TableColLabelValue label={'Contato'} value={contact} width={'50%'} />
          <TableColLabelValue label={'E-mail'} value={email} />
        </TableRow>
        <TableRow>
          <TableColLabelValue colSpan={2} label={'Endereço. Completo'} value={getAddressValue(serviceOrder)} />
        </TableRow>
      </Table>
      <Separator weight={4} />
      <Bar />
    </View>
  )
}

export default ClientData
